import axios from 'axios';

const instance = axios.create({
  baseURL: `https://${process.env.VUE_APP_DASH_SERVER_HOST}`,
  timeout: 300000
});

export default instance;
